import { useState, useEffect, useMemo } from "react";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { removeZero } from "../../../SharedComponents/utils/helpers/dataHelpers";


const DynamicTimeLabel = ({ state, createdAt, collectOffersTime, selectWinnerTime }) => {

    const calculateTimeLeft = (createdAt, timeToStart) => {
        const start = +new Date(createdAt).getTime() + timeToStart;

        const difference = start - +new Date().getTime();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                d: Math.floor(difference / (1000 * 60 * 60 * 24)),
                h: Math.floor((difference / (1000 * 60 * 60)) % 24),
                m: Math.floor((difference / 1000 / 60) % 60),
                s: Math.floor((difference / 1000) % 60),
            };
        }

        return timeLeft;
    }

    const timeToStart = (collectOffersTime, selectWinnerTime, state) => {
        switch (state) {
            case 1:
                return collectOffersTime * 1000;
            case 2:
                return (selectWinnerTime + collectOffersTime) * 1000;

            default:
                return false;
        }
    };


    const startTime = useMemo(() => {
        return calculateTimeLeft(createdAt, timeToStart(collectOffersTime, selectWinnerTime, state));
    }, [state, collectOffersTime, selectWinnerTime]);

    const [timeLeft, setTimeLeft] = useState(startTime);

    const timerComponents = useMemo(() => {
        let timeObject = removeZero({ ...timeLeft });
        let timeKeys = Object.keys(timeObject);

        if (timeKeys.length) {
            return (
                <p>
                    {timeObject[timeKeys[0]]} {timeKeys[0]}
                </p>
            );
        }

        return;
    }, [timeLeft]);



    useEffect(() => {
        const interval = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(createdAt, timeToStart(collectOffersTime, selectWinnerTime, state)));
        }, 1000);
        return () => {
            clearTimeout(interval);
        };
    });

    return (
        <div style={styles.container}>
            {
                timerComponents
                    ? timerComponents
                    : <p>{'0 s'}</p>
            }
        </div>
    );
};

export default DynamicTimeLabel;


const styles = {
    container: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    labelText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        paddingVertical: 2,
        fontSize: 14,
        lineHeight: 20,
        marginLeft: -1,
    },
}